<template>
  <WdsText class="tw-truncate" :text="date" />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import useDate from '@/composables/useDate'

const ClientAddedColumn = graphql(`
  fragment ClientAddedColumn on CompanySupplier {
    id
    createdAt
  }
`)

const props = defineProps<{
  row: FragmentType<typeof ClientAddedColumn>
}>()

const column = computed(() => useFragment(ClientAddedColumn, props.row))
const { date } = useDate(computed(() => column.value.createdAt))
</script>
